import { makeStyles } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  fullWidth: {
    backgroundColor: "#fafafa",
    maxWidth: 1970,
    padding: 0,
  },

  btnFullscreen: {
    position: "fixed",
    background: "#b01010",
    color: "#fff",
    right: 25,
    bottom: 25,

    "&:hover": {
      background: "#960d0d",
      color: "#fff",
    },
  },

  wrapperSeals: {
    padding: 40,

    display: "flex",
    flexDirection: "column",
    gap: 40,

    [theme.breakpoints.down("sm")]: {
      padding: 0,
    },
  },

  wrapperTitle: {
    display: "flex",
    flexDirection: "column",
    gap: 10,

    "& .MuiTypography-h1": {
      fontSize: 24,
      color: "#0C0F18",
      fontWeight: "bold",
    },

    "& .MuiTypography-span": {
      fontSize: 16,
      console: "#5D5656",
    },
  },

  wrapperSealsActive: {
    display: "flex",
    flexDirection: "column",
    gap: 10,

    "& .MuiTypography-h2": {
      fontSize: 24,
      color: "#0C0F18",
      fontWeight: "bold",
    },

    "& .seals": {
      display: "flex",
      flexWrap: "wrap",
      padding: 0,
      gap: 10,
    },
  },

  cardSeals: {
    maxWidth: 260,
    width: "100%",
    borderRadius: 6,
    height: 49,
    border: "1px solid #E0E0E0",
    boxShadow: "none",

    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "8px 10px",

    "& > div": {
      display: "flex",
      gap: 2,
      flexDirection: "column",

      "& p": {
        fontSize: 14,
        color: "#5D5656",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        maxWidth: 170,
      },

      "& span": {
        fontSize: 12,
        color: "#818284",
      },
    },

    "& .MuiButton-root": {
      width: 20,
      padding: 0,
      minWidth: 20,
      marginLeft: "auto",
    },
  },

  modalPreviewSeal: {
    "& > .MuiDialog-container .MuiDialog-paper": {
      maxWidth: 690,
      width: "100%",
    },
  },

  wrapperSealExclud: {
    display: "flex",
    maxWidth: 650,
    width: "100%",
    gap: 20,
    marginBottom: 20,
  },

  containerImport: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    justifyContent: "space-between",

    "& > button": {
      width: "100%",
      maxWidth: 260,
      background: "#FF314A",
      color: "#fff",
      marginTop: "auto",

      "&:hover": {
        background: "#FF314A",
        color: "#fff",
      },
    },
  },

  containerSealExclud: {
    display: "flex",
    flexDirection: "column",
    gap: 10,

    "& > button": {
      width: "100%",
      maxWidth: 260,
      background: "#1BA441",
      color: "#fff",

      "&:hover": {
        background: "#1BA441",
        color: "#fff",
      },
    },
  },

  sealExclud: {
    display: "flex",
    border: "1px solid #E0E0E0",
    borderRadius: 6,
    padding: "8px 10px",
    gap: 10,
    alignItems: "center",
    maxWidth: 260,
    width: "100%",
    height: 49,
    justifyContent: "space-between",

    '& [data-element="seal"]': {
      display: "flex",
      gap: 10,
      alignItems: "center",

      "& p": {
        fontSize: 14,
        color: "#5D5656",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        maxWidth: 150,
      },
    },
  },

  containerFlagsEdit: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginBottom: 20,

    '& [data-element="flag-edit"]': {
      display: "flex",
      gap: 10,
      alignItems: "center",
      maxWidth: 280,
      border: "1px solid #E0E0E0",
      borderRadius: 6,
      padding: "8px 10px",

      '& [data-element="flag-edit-info"]': {
        display: "flex",
        gap: 5,
        flexDirection: "column",

        "& p": {
          fontSize: 14,
          color: "#5D5656",
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
          maxWidth: 150,
        },
      },

      "& button": {
        width: 30,
        padding: 5,
        minWidth: 20,
        marginLeft: "auto",
      },
    },
  },

  containerActionsSeal: {
    display: "flex",
    gap: 10,
    marginBottom: 20,

    "& [data-element='add-products']": {
      display: "flex",
      gap: 10,
      alignItems: "center",
      maxWidth: 280,
      border: "1px solid #E0E0E0",
      borderRadius: 6,
      padding: "8px 10px",
      background: "#1BA441",
      cursor: "pointer",

      "& label": {
        cursor: "pointer",
        "& span": {
          fontSize: 14,
          color: "#fff",
        },
      },
    },

    '& [data-element="exclude-seal"]': {
      "& button": {
        display: "flex",
        gap: 10,
        alignItems: "center",
        maxWidth: 280,
        border: "1px solid #E0E0E0",
        borderRadius: 6,
        padding: "8px 10px",
        background: "#FF314A",
        cursor: "pointer",
        color: "#fff",
        textTransform: "capitalize",
      },
    },
  },

  containerChangeSeal: {
    display: "flex",
    gap: 10,
    flexDirection: "column",

    "& h3": {
      fontSize: 24,
      color: "#0C0F18",
      fontWeight: "bold",
    },

    "& p": {
      fontSize: 14,
      color: "#5D5656",
    },

    '& [data-element="change-seal-action"]': {
      display: "flex",
      gap: 10,
      alignItems: "center",
      maxWidth: "100%",

      "& [data-element='change-seal-cancel']": {
        border: "1px solid #E0E0E0",
        borderRadius: 6,
        padding: "8px 10px",
        background: "#F4F4F4",
        color: "#818284",
        cursor: "pointer",
        outline: "none",
        boxShadow: "none",
        maxWidth: 175,
        width: "100%",
      },

      "& [data-element='change-seal-accept']": {
        borderRadius: 6,
        padding: "8px 10px",
        background: "#1BA441",
        color: "#fff",
        cursor: "pointer",
        textAlign: "center",
        outline: "none",
        boxShadow: "none",
        maxWidth: 175,
        width: "100%",
        height: "100%",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },

      "& [data-element='exclude-seal']": {
        display: "flex",
        gap: 10,
        alignItems: "center",
        maxWidth: 280,
        border: "1px solid #E0E0E0",
        borderRadius: 6,
        padding: "8px 10px",
        background: "#FF314A",
        cursor: "pointer",

        "& label": {
          cursor: "pointer",
          "& span": {
            fontSize: 14,
            color: "#fff",
          },
        },
      },
    },
  },

  containerModalContent: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },

  dialogContent: {
    padding: "40px !important",
  },

  loading: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
  },

  modalClose: {
    position: "absolute",
    right: 10,
    top: 6,
    minWidth: 20,
    cursor: "pointer",
  },
}));

export default useStyle;
